export default "__VITE_ASSET__CseBsazM__"